import { render, staticRenderFns } from "./Reassign.vue?vue&type=template&id=6c16ffc3&scoped=true&"
import script from "./Reassign.vue?vue&type=script&lang=js&"
export * from "./Reassign.vue?vue&type=script&lang=js&"
import style0 from "./Reassign.vue?vue&type=style&index=0&id=6c16ffc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c16ffc3",
  null
  
)

export default component.exports